export default {
  isLoading: state => state.loading,
  transactions: state => state.widgets.transactions,
  convertion: state => state.widgets.convertion,
  hits: state => state.widgets.hits,
  events: state => state.widgets.events,
  responsiveness: state => state.widgets.responsiveness,
  weather: state => state.widgets.weather,
  jsFrameworks: state => state.widgets.jsFrameworks,
  topWines: state => state.widgets.topWines,
}